import { render, staticRenderFns } from "./SummaryAbsorptionScattering.vue?vue&type=template&id=4d2331fe&scoped=true&"
import script from "./SummaryAbsorptionScattering.vue?vue&type=script&lang=ts&"
export * from "./SummaryAbsorptionScattering.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryAbsorptionScattering.vue?vue&type=style&index=0&id=4d2331fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2331fe",
  null
  
)

export default component.exports